import { Component, input } from "@angular/core";
import { PeriodDefinitionType } from "@models/map/market-filter.model";
import { ThousandizePipe } from "ev-core";
import { StatisticsLine } from "src/models/estate/IResidenceSaleInArea";
import { SearchViewOptionsFilterModel } from "../../../estate-filter/search-filter-view-options/search-filter-view-options.model";
import { StatisticsPriceassumptionComponent } from "../statistics-priceassumption/statistics-priceassumption.component";
import { StatisticsSoldComponent } from "../statistics-sold/statistics-sold.component";

@Component({
    selector: "market-price-statistics-estate",
    imports: [ThousandizePipe, StatisticsSoldComponent, StatisticsPriceassumptionComponent],
    templateUrl: "./market-price-statistics-estate.component.html",
    styleUrl: "../market-price-statistics/market-price-statistics.component.scss",
})
export class MarketPriceStatisticsEstateComponent {
    estateStat = input.required<StatisticsLine>();
    searchViewOptions = input.required<SearchViewOptionsFilterModel>();

    periodType = PeriodDefinitionType;
    showDetails = false;
}
